import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { LanguageStore, LanguageState } from './language.store';

@Injectable({ providedIn: 'root' })
export class LanguageQuery extends Query<LanguageState> {

  constructor(protected store: LanguageStore) {
    super(store);
  }

  get currentLanguageKey() {
    return this.getValue().key
  }

}
